<template>
  <div>
    <div class="row">
        <div class="col-3">
            <MdLookupMultiSelect
                v-bind:Label="$tc('Shared.Patient',2)"
                v-bind:ModelCode="patientCode"
                v-bind:RefCode="'patientcode'"
                v-bind:Api="'Patients'"
                v-bind:FieldCode="'patientcode'"
                v-bind:FieldDescription="'firstname'"
                :SearchTitle="$tc('Shared.Patient',2)"
                :GetValues="getValues"
                :InvalidFeedback="$t('Msg.InvalidCode')"
                :SearchFieldCode="'PatientCode'"
                :AuxFields="AuxFields"
                :FieldsDate="fieldsDate"
                v-bind:Fields="BaseFields"
                :ServerSidePagination="true"
            />
        </div>
    </div>
     
  </div>
</template>

<script>

export default {
  data() {
    return {
        AuxFields:['lastname'],
        fieldsDate:['dob'],
        patientCode: ['004095'],
        BaseFields:[
            { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
            { key: 'lastname', sortable: true, label: this.$t('Shared.LastName')},
            { key: 'patientcode', sortable: true, label: this.$t('Shared.Code')},
            { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone')},
            { key: 'address1', sortable: true, label: this.$t('Shared.Address1')},
            { key: 'city', sortable: true, label: this.$t('Shared.City')},
            { key: 'state', sortable: true, label: this.$t('Shared.State')},
            { key: 'country', sortable: true, label: this.$t('Shared.Country')},
            { key: 'zip', sortable: true, label: this.$t('Shared.Zip')}
      ]
    }
  },

  methods: {
    getValues: function (value) {
        this.patientCode = value
        console.log('getvalues',value)
    },
  }
}
</script>

<style>

</style>